if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"NuOrderFrontend","remotes":[{"alias":"OrderIntents","name":"OrderIntents","entry":"/federated/order-intents/remoteEntry.js","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return !/^1(5[236789]|6[0123456789]|7[012])$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}